export default __webpack_public_path__ + "static/media/previous_slice.2eca27e6.svg";